export enum PaymentMethodType {
  ACH = 0,
  CREDIT = 1,
}
